import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'

const SIGNATURE_ACCESS_KEY: any =
  process.env.REACT_APP_SIGNATURE_ACCESS_KEY || 'SIGNATURE_ACCESS_KEY'

const encryptValue = (value) => {
  return CryptoJS.AES.encrypt(JSON.stringify(value), SIGNATURE_ACCESS_KEY).toString()
}

const decryptValue = (encryptedValue) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, SIGNATURE_ACCESS_KEY)
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8)
    if (!decryptedString) {
      return null
    }
    return JSON.parse(decryptedString)
  } catch (error) {
    console.warn('Failed to decrypt value:', error)
    return null
  }
}

// BEGIN: Cookies
const getItemCookies = (key) => {
  const encryptedValue = Cookies.get()[key]
  if (encryptedValue) {
    return decryptValue(encryptedValue)
  }
  return null
}

const setItemCookies = (key, value, options = {}) => {
  const encryptedValue = encryptValue(value)
  Cookies.set(key, encryptedValue, options)
}

const removeItemCookies = (key) => {
  Cookies.remove(key)
}

const clearItemCookies = () => {
  const cookies = Object.keys(Cookies.get())
  const preservedCookies = [
    'usps_disclaimer_acknowledged',
    'market_promo_banner_visible',
    'CookieConsent',
  ]
  for (let i = 0; i < cookies.length; i++) {
    if (!preservedCookies.includes(cookies[i])) {
      Cookies.remove(cookies[i])
    }
  }
}
//  END: Cookies

// BEGIN: Local
const getItemLocalStorage = (key) => {
  const encryptedValue = localStorage.getItem(key)
  if (encryptedValue) {
    return decryptValue(encryptedValue)
  }
  return null
}

const setItemLocalStorage = (key, value) => {
  const encryptedValue = encryptValue(value)
  localStorage.setItem(key, encryptedValue)
}

const removeItemLocalStorage = (key) => {
  localStorage.removeItem(key)
}

const preservedLocalStorageKeys = ['CookieConsent']

const clearItemLocalStorage = () => {
  const keys = Object.keys(localStorage)
  for (let i = 0; i < keys.length; i++) {
    if (!preservedLocalStorageKeys.includes(keys[i])) {
      localStorage.removeItem(keys[i])
    }
  }
}
// END: Local

const storageClear = () => {
  clearItemCookies()
  clearItemLocalStorage()
  sessionStorage.clear()
}

export const StorageHelpers = {
  getItemCookies,
  setItemCookies,
  removeItemCookies,
  clearItemCookies,
  getItemLocalStorage,
  setItemLocalStorage,
  removeItemLocalStorage,
  clearItemLocalStorage,
  storageClear,
}
